import{j as r}from"../../node_modules/react/jsx-runtime.js";import{createContext as e}from"react";var o=e({}),t=function(e){var t=e.children,n=e.metaInfo;return r.jsx(o.Provider,{value:n,children:t})};export{t as Interceptor,o as InterceptorContext};
//# sourceMappingURL=index.js.map
